import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const HomeHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge lp-badge--up" data-lp-reveal><span />AI-powered transaction readiness</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Rigorous diligence.<br />Days, not months.<br /><span style={{ color: '#FC7785' }}>£1,000, not £40,000.</span></h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">70% of SME investments go undiligenced — not because investors don't care, but because thorough diligence has historically been unaffordable. Diligentsia changes that. AI-powered, human-verified transaction readiness for companies, advisors, and investors across the UK SME ecosystem.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <Link className="lp-btn lp-btn--primary" to={ROUTES.REGISTER}>Get started free</Link>
                </div>
                <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#FC7785', display: 'inline-block', flex: 'none' }} />
                    Trusted by 50+ investors, advisors, and growing companies · No credit card required
                </div>
            </div>

            <div className="lp-hero-art">
                <img className="lp-hero-img lp-float" style={{ borderRadius: '20px' }} src={require('../../../../images/landing-pages/home-page/homepage-top-banner.png')} alt="Diligentsia connects companies, advisors, and investors" />
            </div>
        </div>
    </section>
);

export default HomeHeroSection;
